var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurantDining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2563eb",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 45.001 45.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.73,21.939c-0.525-8.071-6.996-14.56-15.197-15.313c0.066-0.182,0.109-0.375,0.109-0.58 c0-0.942-0.767-1.705-1.705-1.705c-0.941,0-1.707,0.763-1.707,1.705c0,0.205,0.043,0.398,0.106,0.58 C16.139,7.379,9.668,13.868,9.141,21.939h-2.27c0,1.139,0.924,2.063,2.064,2.063h1.851c-2.144,1.083-5.095,3.995-5.095,3.995 l6.771,6.841l2.418-1.446h13.78l9.389-9.39h4.889c1.14,0,2.063-0.924,2.063-2.063H42.73z M27.844,28.929c0,0-4.486,0-6.438,0 c-0.914,0-3.063-1.996-3.063-1.996s4.082,0,5.714,0c2.605,0,3.916-2.05,4.359-2.931h6.01C32.07,25.332,27.844,28.929,27.844,28.929 z M4.08,27.562l9.021,9.021l-4.08,4.078L0,31.64L4.08,27.562z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantDining);
export default __webpack_public_path__ + "static/media/restaurant-dining.f86ad00fa390f0772afc299046d29d4d.svg";
export { ForwardRef as ReactComponent };